import type { MessageDescriptor } from 'react-intl';

export const CREATE_APP_TITLE: MessageDescriptor = {
  id: 'apps.builder.create.dialog.title',
  defaultMessage: 'What should your app do?',
};

export const CREATE_APP_TIPS: readonly MessageDescriptor[] = [
  {
    id: 'apps.builder.create.tip.files',
    defaultMessage:
      'Mention the files your app takes in and what it should hand back. I fill in everything else with sensible defaults.',
  },
  {
    id: 'apps.builder.create.tip.attach',
    defaultMessage: 'Attach a sample file with + and I shape the app around it.',
  },
  {
    id: 'apps.builder.create.tip.skills',
    defaultMessage: 'Add a skill when the job needs specialist tools. I only load the ones you pick.',
  },
  {
    id: 'apps.builder.create.tip.examples',
    defaultMessage: 'Not sure where to start? Pick one of the examples below.',
  },
];

export const HERO_ORB_PX = 170;
export const SHORT_VIEWPORT_QUERY = '(max-height: 520px)';
